import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";

import { SeoRenderer } from "../../../common/helpers/seo";

import { post, get } from "../../actions/general";
import { getPacks, createPack, deletePack } from "../../store/dashboard/actions";
import { IStateTree } from "../../store/interfaces";

import loadableComponent from "./loadable";
import { Store } from "redux";
import { IUser } from "../../store/user/models";

const mapStateToProps = (state: IStateTree) => ({
    user: state.user as IUser,
    packs: state.packs.packs,
    isPackLoading: !!state.packs.loading,
    isPackError: !!state.packs.error,
});

export default {
    component: withRouter(
        connect(mapStateToProps, { post, get, getPacks, createPack, deletePack })(
            injectIntl(loadableComponent)
        )
    ),
    renderSeo: (store: Store, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({ title: allMessage["menu.editor"], allMessage, lang });
    },
};
